/**
 * AtlasToggle — sticky кнопка для открытия экрана Атласа открытий.
 *
 * Размещение: top-right corner. Settings — bottom-right, Upgrades —
 * bottom-left, Atlas — top-right. Три угла, никаких коллизий.
 *
 * Прячется когда атлас уже открыт (в нём свой ✕ для закрытия).
 */
import { useAnchor } from '../onboarding/useAnchor.js';
import { useNavigationStore } from '../screens/navigation.js';
import styles from './AtlasToggle.module.css';

export function AtlasToggle(): JSX.Element | null {
  const screen = useNavigationStore((s) => s.current);
  const setScreen = useNavigationStore((s) => s.setScreen);
  const buttonAnchor = useAnchor<HTMLButtonElement>('atlas');

  // Don't render in Atlas screen — it has its own close button.
  if (screen === 'atlas') return null;

  return (
    <button
      ref={buttonAnchor}
      type="button"
      className={styles.toggle}
      onClick={() => {
        setScreen('atlas');
      }}
      aria-label="Открыть атлас памяти"
    >
      <span aria-hidden>◈</span>
      <span className={styles.label}>атлас</span>
    </button>
  );
}
